import React from 'react';
import useUser from '../store/selectors/useUser';
import useApiPost from '../api/useApiPost';
import useSelectedTemplateId from '../store/selectors/useSelectedTemplateId';

const buildFormData = ({ uId, templateId }) => {
  let formData = new FormData();
  formData.set('hID', 'getTemplateOptions');
  formData.set('uID', uId);
  formData.set('tID', templateId);  
  return formData;
};

const mapResponseToData = response => {
  return {
    subjects: response.data.result.subjects,
    subtexts: response.data.result.subtexts,
    greetings: response.data.result.greetings,
    intros: response.data.result.intros,
    closings: response.data.result.closings,
    smses: response.data.result.smses,
    onSubject: response.data.result.subjects[0],
    onGreeting: response.data.result.greetings[0],
    onIntro: response.data.result.intros[0],
    onSms:  response.data.result.smses[0],
  };
};

const defaultTemplateOptions = {
  subjects: [],
  subtexts: [],
  greetings: [],
  intros: [],
  smses: []
};

export default function useTemplateOptions() {
  const { id: uId } = useUser();
  const templateId = useSelectedTemplateId();

  const { data, handlePost, loading, error } = useApiPost({ mapResponseToData, defaultData: defaultTemplateOptions });

  const handleRefresh = React.useCallback(
    ({ onSuccess, onError }) => handlePost({ onSuccess, onError, data: buildFormData({ uId, templateId }) }),
    [uId, templateId, handlePost]
  );

  return { templateOptions: data, loadingTemplateOptions: loading, error, handleRefresh };
}
